import {useCallback} from "react";
import ReduxFetchState from "redux-fetch-state";
import {put, takeEvery} from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import {getCurrentLanguage} from "../../../../Utils/sagaHelpers";
import {useAppDispatch, useAppSelector} from "../../../../Hooks/useStore";
import {alert} from "../../../../Utils/toast";
import {ShowBotsTypes} from "../../../../Schema/showBots.types";

export type ShowBotsLoadAction = {
    type: string;
    payload: { username: string };
};

export type ShowBotsData = {
    data: ShowBotsTypes;
};

const ShowBots = new ReduxFetchState<
    ShowBotsData,
    { username: string },
    any
>("showBots");

const RESET_SHOW_BOTS = "RESET_SHOW_BOTS";

export function* watchShowBots(action: ShowBotsLoadAction) {
    try {
        const lang: "fa" | "en" = yield getCurrentLanguage();

        const {username} = action.payload;
        const data: ShowBotsData = yield axios({
            url: `/api/v1/ai/agency/${username}/show`,
            method: "GET",
            headers: {lang},
        });

        yield put(ShowBots.actions.loadSuccess({data: data.data}));
    } catch (e: any) {
        alert({message: "مشکلی پیش آمده", type: "error"});
        yield put(ShowBots.actions.loadFailure(e.message));
    }
}

export function* showBotsSagas() {
    yield takeEvery(ShowBots.actionTypes.load, watchShowBots);
}

const initialState = ShowBots.reducer(undefined, {
    type: "@@INIT",
});

const customReducer = (
    state = initialState,
    action: any,
) => {
    if (action.type === RESET_SHOW_BOTS) {
        return initialState;
    }

    return ShowBots.reducer(state, action);
};

export function useShowBots() {
    const { loading, data, ...showBotsState } = useAppSelector(
        (state) => state.showBots,
    );

    const dispatch = useAppDispatch();

    const dispatchShowBots = useCallback(
        (data: { username: string }) => {
            dispatch(ShowBots.actions.load(data));
        },
        [dispatch],
    );

    const clearShowBots = useCallback(() => {
        dispatch({ type: RESET_SHOW_BOTS });
    }, [dispatch]);

    return {
        ...showBotsState,
        dispatchShowBots,
        clearShowBots,
        showBotsLoading: loading,
        showBotsData: data,
    };
}

export const {
    actionTypes: showBotsActionsTypes,
    actions: showBotsActions,
} = ShowBots;

export const showBotsReducer = customReducer;